<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header-content full-width">
                <div class="title">
                    Running total
                </div>
                <div v-if="finalTotal && !loading" class="text-success fw-600">
                    ${{ finalTotal }} 
                </div>
                <div v-if="countPending > 0 && !loading" class="alert alert-secondary mt-2 mb-0">
                  <i class="fas fa-search-dollar mr-2"></i> There {{ isOrAre }} <span class="link clickable" @click="clickedChangeOrders">{{ countPending }} change order{{ pluralize }}/selection{{ pluralize }} (${{ totalPending }})</span> not included below because {{ itIsOrTheyAre }} still pending approval.
                </div>
            </div>
        </div>
        <div>
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th scope="col">Item</th>
                  <th scope="col">Cost</th>
                  <th scope="col">Tax</th>
                  <th scope="col">Total</th>
                </tr>
              </thead>
              <tbody v-if="loading">
                  <tr>
                      <td>
                          <span class="loader"></span>
                      </td>
                  </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="item in items">
                  <td>{{ item.title }}</td>
                  <td>{{ item.price }}</td>
                  <td>{{ item.tax }}</td>
                  <td>{{ item.total }}</td>
                </tr>
                <tr>
                    <th scope="col">Total</th>
                    <th>${{ subtotal }}</th>
                    <th>${{ taxTotal }}</th>
                    <th>${{ finalTotal }}</th>
                </tr>
              </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'project'],

        created: function() {
          this.registerEvents();
          this.getRunningTotal();
        },

        mounted: function() {

        },

        data: function() {
            return {
                items: [],
                subtotal: null,
                taxTotal: null,
                finalTotal: null,
                countPending: 0,
                totalPending: null,
                loading: true,
                error: false, 
            };
        },

        watch: {
            project: function() {
                this.refresh();
            }
        },

        computed: {
          isOrAre: function() {
            return this.countPending == 1 ? 'is' : 'are';
          },

          pluralize: function() {
            return this.countPending == 1 ? '' : 's';
          },

          itIsOrTheyAre: function() {
            return this.countPending == 1 ? 'it is' : 'they are';
          },
        },

        methods: {
          registerEvents: function() {
            var vm = this;
            Bus.$on('change-order-updated', function(changeorder) {
                vm.getRunningTotal();
            });
            Bus.$on('selection-updated', function(changeorder) {
                vm.getRunningTotal();
            });
            Bus.$on('new-change-order-created', function(changeorder) {
                vm.getRunningTotal();
            });
            Bus.$on('new-selection-created', function(changeorder) {
                vm.getRunningTotal();
            });
            Bus.$on('change-order-deleted', function(changeorder) {
                vm.getRunningTotal();
            });
            Bus.$on('selection-deleted', function(changeorder) {
                vm.getRunningTotal();
            });
          },

          clickedChangeOrders: function() {
              $('a[href="#change-orders"]').trigger('click');
          },

          getRunningTotal: function() {
               if (!this.project) {
                   return;
               }
               
               this.changeorders = [];
               axios.get(`/api/projects/${this.project.id}/runningTotal`)
                   .then(response => {
                       this.loading = false;
                       this.error = false;
                       this.items = response.data.items;
                       this.subtotal = response.data.subtotal;
                       this.taxTotal = response.data.taxTotal;
                       this.finalTotal = response.data.finalTotal;
                       this.totalPending = response.data.totalPending;
                       this.countPending = response.data.countPending;

                       // 'items' => $items,
                       // 'subtotal' => number_format(round($subtotal, 2), 2),
                       // 'taxTotal' => number_format(round($taxTotal, 2), 2),
                       // 'finalTotal' => number_format(round($finalTotal, 2), 2),
                       // 'totalPending' => number_format(round($totalPending, 2), 2),
                       // 'countPending' => $countPending,
                   })
                   .catch(error => {
                       this.loading = false;
                       this.error = true;
                   });
           },

           refresh: function() {
               this.loading = true;
               this.getRunningTotal();
           },
        }
    }
</script>
